import { IntlShape } from "react-intl";

import { EntityType } from "@mapmycustomers/shared";

import { getEntityTypeDisplayName } from "@app/util/ui";

import messages from "../messages";
import RecipientType from "../RecipientType";

const getRecipientTypeDisplayName = (intl: IntlShape, recipientType: RecipientType) => {
  switch (recipientType) {
    case RecipientType.Company:
      return getEntityTypeDisplayName(intl, EntityType.COMPANY, {
        lowercase: false,
        plural: true,
      });
    case RecipientType.CompanyPerson:
      return intl.formatMessage(messages.modalCompanyPersonRecipientType);
    case RecipientType.Person:
      return getEntityTypeDisplayName(intl, EntityType.PERSON, {
        lowercase: false,
        plural: true,
      });
  }
};

export default getRecipientTypeDisplayName;
